import { render, staticRenderFns } from "./marketingShareDetail.vue?vue&type=template&id=528dd208&"
import script from "./marketingShareDetail.vue?vue&type=script&lang=js&"
export * from "./marketingShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketingShareDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports